import { IWinData } from "../../../vendor_core/core/src/server/data/ISpinData";
import PromiseHelpers from "../../../vendor_core/core/src/utils/PromiseHelpers";
import WinSymbolsView from "../../../vendor_core/core/src/views/WinSymbolsView";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import BURCascadeReelGroup from "./BURCascadeReelGroup";
import BURReelSymbol from "./BURReelSymbol";

export default class BURWinSymbolsView extends WinSymbolsView {
    public playWinLineSymbols(
        winLineData: IWinData,
        ids: number[]
    ): Promise<boolean> {
        let promises: Promise<boolean>[] = [];
        const winLine = winLineData.coordinates;
        this.scene.containers.get("wins")?.enableMask();
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = <BURCascadeReelGroup>scene.getSubView("ReelGroup");

        winLine?.forEach((symWin) => {
            const symSpine = reelGroup.getSymbolAt(symWin.x - 1, symWin.y - 1);
            promises.push((symSpine as BURReelSymbol).playAsync("win"));
        });
        return PromiseHelpers.combineParallel(promises);
    }

    public hideWinlineWinSymbols(winLineData: IWinData) {
        // do not delete
    }
}
